<template>
  <div>
    <div class="relative flex items-center">
      <input
        :value="true"
        :name="name"
        type="checkbox"
        class="size-6 rounded text-primary focus:ring-primary"
        :class="
          hasError
            ? 'border-error'
            : 'border-background-fg/30'
        "
        :checked="checked"
        @change="handleChange"
      />
      <label
        :for="name"
        class="ml-3 text-sm font-medium text-background-fg/70"
      >
        <slot name="label">
          {{ label }}
        </slot>
      </label>
    </div>
    <p
      v-if="hasError"
      class="mt-1 text-xs font-medium text-error"
    >
      {{ errorMessage }}
    </p>
  </div>
  <p
    v-if="errorMessage"
    class="text-xs font-medium text-error"
  >
    {{ errorMessage }}
  </p>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"

const props = defineProps<{
  label?: string
  name: string
}>()

defineEmits<{
  (event: "update:modelValue", value: boolean): void
}>()

const { checked, handleChange, errorMessage } = useField(
  toRef(props, "name"),
  undefined,
  {
    type: "checkbox",
    checkedValue: true,
    uncheckedValue: false,
  }
)

const hasError = computed(() => !!errorMessage.value)
</script>
